import { StandardSelectOption } from "../../components/selector/parts/SelectOption";
import {
  DataSourceSortOption,
  DataSourceSortOptionName,
} from "../../types/dataSource/dataSource";

export function getDataSourceSortOptions(): StandardSelectOption<DataSourceSortOption>[] {
  return Object.values(DataSourceSortOption).map((value) => ({
    value,
    data: {
      label: DataSourceSortOptionName[value],
    },
  }));
}
